// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__bNe7S","active":"style_active__Fo4re"};